export default __webpack_public_path__ + "static/media/DeltaLogo.2b1d5b0c.svg";